import firebase from "firebase";

export const leadsAdd = async data => {
  let callable = firebase.functions().httpsCallable("leadsAdd");
  return callable(data).then(result => result.data);
};

export const leadsImport = async data => {
  let callable = firebase.functions().httpsCallable("leadsImport");
  return callable(data).then(result => result.data);
};

export const comment = async data => {
  let callable = firebase.functions().httpsCallable("leadsComment");
  return callable(data).then(result => result.data);
};
export const commentHandler = async data => {
  try {
    await comment(data);
    return {
      ok: true
    };
  } catch (e) {
    return { error: e.message };
  }
};

export const fixSource = async leadId => {
  let callable = firebase.functions().httpsCallable("fixSource");
  return callable({ leadId }).then(result => result.data);
};

export const visit = async leadId => {
  let callable = firebase.functions().httpsCallable("leadVisit");
  return callable({ leadId }).then(result => result.data);
};

export const parseInboundEmail = async (id, save) => {
  let callable = firebase.functions().httpsCallable("parseInboundEmail");
  return callable({ id, save }).then(result => result.data);
};
